import { render, staticRenderFns } from "./banner-schedule-list.vue?vue&type=template&id=2bd6c744&scoped=true&"
import script from "./banner-schedule-list.vue?vue&type=script&lang=js&"
export * from "./banner-schedule-list.vue?vue&type=script&lang=js&"
import style0 from "./banner-schedule-list.vue?vue&type=style&index=0&id=2bd6c744&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd6c744",
  null
  
)

export default component.exports